import classNames from "classnames";
import { ReactComponentElement } from "react";

import ScrollToTopOnMount from "features/common/routing/ScrollToTopOnMount";
import { isIOS } from "features/common/utils/functions/mobile";

import LogoComponent from "./LogoComponent";
import styles from "./LogoPageWrapper.module.scss";

type Props = {
  children: ReactComponentElement<any, any> | ReactComponentElement<any, any>[];
};

export default function LogoPageWrapper({ children }: Props) {
  return (
    <ScrollToTopOnMount>
      <div
        className={classNames(styles.wrapper, {
          [styles.relative]: !isIOS()
        })}
      >
        <LogoComponent />
        {children}
      </div>
    </ScrollToTopOnMount>
  );
}
